export default __webpack_public_path__ + "navigation-examples-basic-thumbnail-v1-480-39772b913110f08c1282f592a8c1ecf8.webp";